import Guard from '@/services/middleware'

import ChatLayout from '@/layouts/ChatLayout.vue'
// import HomeChat from '@/views/chat/HomeChat.vue'
const HomeDash = () => import('@/views/chat/pages/Dashboard/Home.vue')
const HomeChat = () => import('@/views/chat/pages/Chat/Home.vue')
const HomeKanban = () => import('@/views/chat/pages/Dashboard/Kanban.vue')
const DownloadMessage = () => import('@/views/chat/pages/Messages/Download.vue')
const PrintAttendance = () => import('@/views/chat/pages/Chat/PrintAttendance.vue')
const HomeClients = () => import('@/views/chat/pages/Chat/Clients.vue')
const HomeCampanhas = () => import('@/views/chat/pages/Chat/Campanhas.vue')
const CRMHome = () => import('@/views/crm/index.vue')
const CRMFlow = () => import('@/views/crm/Flow.vue')

export default [
    {
        path: '/chat',
        component: ChatLayout,
        beforeEnter: Guard.redirectIfNotAuthenticated,
        children: [
            {
                path: '', name: 'chat.dash.home',
                component: HomeDash,
                meta: { title: 'Dashboard de atendimento' },
            },
            {
                path: 'crm/:id?',
                name: 'chat.crm',
                component: CRMHome,
                meta: { title: 'CRM' },
            },
            {
                path: 'crm/:id/flow',
                name: 'crm.flow',
                component: CRMFlow,
                meta: { title: 'Automação CRM' },
            },
            {
                path: 'dash/encerrados',
                name: 'chat.dash.closed',
                component: HomeDash,
                meta: { title: 'Atendimentos encerrados' },
            },
            {
                path: 'dash/kanban',
                name: 'chat.dash.kanban',
                component: HomeDash,
                meta: { title: 'Atendimentos em kanban' },
            },
            {
                path: 'dash/visaogeral',
                name: 'chat.dash.analytics',
                component: HomeDash,
                meta: { title: 'Visão geral' },
            },
            {
                path: 'dash/atendentes',
                name: 'chat.dash.attendants',
                component: HomeDash,
                meta: { title: 'Atendentes' },
            },
            {
                path: 'dash/canais',
                name: 'chat.dash.channels',
                component: HomeDash,
                meta: { title: 'Canais de contato' },
            },
            {
                path: 'andamento/:id?',
                name: 'chat.attendances.progress',
                component: HomeChat,
                meta: { title: 'Chat de atendimento' },
            },
            {
                path: 'espera/:id?',
                name: 'chat.attendances.waiting',
                component: HomeChat,
                meta: { title: 'Chat de atendimento' },
            },
            {
                path: 'automacao/:id?',
                name: 'chat.attendances.automation',
                component: HomeChat,
                meta: { title: 'Chat de atendimento' },
            },
            {
                path: 'grupos/:id?',
                name: 'chat.attendances.groups',
                component: HomeChat,
                meta: { title: 'Grupos' },
            },
            {
                path: 'auditoria/:id?',
                name: 'chat.audit',
                component: HomeChat,
                meta: { title: 'Auditoria' },
            },
            {
                path: 'clientes',
                name: 'chat.clients',
                component: HomeClients,
                meta: { title: 'Clientes' },
            },
            {
                path: 'campanhas',
                name: 'chat.attendances.campanhas',
                component: HomeCampanhas,
                beforeEnter: Guard.checkModuleAccess,
                meta: { title: 'Campanhas', module: 'mod_campaign' },
            },
        ],
    },
    {
        path: '/chat/mensagem/:id/download',
        name: 'message.download',
        component: DownloadMessage,
        beforeEnter: Guard.redirectIfNotAuthenticated,
        meta: { title: 'Download de mensagem multimídia' },
    },
    {
        path: '/chat/imprimir/:id',
        name: 'chat.attendance.print',
        component: PrintAttendance,
        beforeEnter: Guard.redirectIfNotAuthenticated,
        meta: { title: 'Imprimir atendimento' },
    },
]